import { render, staticRenderFns } from "./ModuleDappsCenter.vue?vue&type=template&id=21404070&"
import script from "./ModuleDappsCenter.vue?vue&type=script&lang=js&"
export * from "./ModuleDappsCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports